class WkHomeFacets extends HTMLElement {
  constructor() {
    super();
    this.onToggle = this.onToggle.bind(this);
  }

  connectedCallback() {
    this.disclosures = Array.from(this.querySelectorAll('.wk-home-facets__disclosure'));
    this.disclosures.forEach((details) => {
      details.addEventListener('toggle', this.onToggle);
    });
  }

  disconnectedCallback() {
    if (!this.disclosures) return;

    this.disclosures.forEach((details) => {
      details.removeEventListener('toggle', this.onToggle);
    });
  }

  onToggle(event) {
    const opened = event.target;

    if (!opened.open) return;

    this.disclosures.forEach((details) => {
      if (details !== opened) {
        details.open = false;
      }
    });
  }
}

class WkHomeSectorSearch extends HTMLElement {
  constructor() {
    super();
    this.input = null;
    this.list = null;
    this.form = null;
    this.paramInput = null;
    this.options = [];
    this.activeIndex = -1;
    this.onInput = this.onInput.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onOptionClick = this.onOptionClick.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
  }

  connectedCallback() {
    this.form = this.querySelector('form');
    this.input = this.querySelector('[id^="SectorSearchInput-"]');
    this.list = this.querySelector('[id^="SectorSearchList-"]');
    this.paramInput = this.querySelector('[data-sector-param-input]');

    if (!this.form || !this.input || !this.paramInput) return;

    if (this.list) {
      this.options = Array.from(this.list.querySelectorAll('.wk-home-sector-search__option'));
      this.list.addEventListener('mousedown', this.onOptionClick);
    }

    this.input.addEventListener('input', this.onInput);
    this.input.addEventListener('focus', this.onFocus);
    this.input.addEventListener('blur', this.onBlur);
    this.input.addEventListener('keydown', this.onKeyDown);
    document.addEventListener('click', this.onDocumentClick);
  }

  disconnectedCallback() {
    if (!this.input) return;

    this.input.removeEventListener('input', this.onInput);
    this.input.removeEventListener('focus', this.onFocus);
    this.input.removeEventListener('blur', this.onBlur);
    this.input.removeEventListener('keydown', this.onKeyDown);

    if (this.list) {
      this.list.removeEventListener('mousedown', this.onOptionClick);
    }

    document.removeEventListener('click', this.onDocumentClick);
  }

  getAvailableOptions() {
    if (!this.list) return [];

    const query = this.input.value.trim().toLowerCase();

    return this.options.filter((option) => {
      if (option.dataset.disabled === 'true') return false;
      if (!query) return true;
      return (option.dataset.label || option.textContent).trim().toLowerCase().includes(query);
    });
  }

  renderOptions() {
    if (!this.list) return;

    const available = this.getAvailableOptions();

    this.options.forEach((option) => {
      option.hidden = !available.includes(option);
    });

    if (available.length === 0) {
      this.closeList();
      return;
    }

    this.openList();
    this.activeIndex = -1;
    this.highlightOption();
  }

  openList() {
    if (!this.list) return;

    this.list.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
  }

  closeList() {
    if (!this.list) return;

    this.list.hidden = true;
    this.input.setAttribute('aria-expanded', 'false');
    this.activeIndex = -1;
    this.highlightOption();
  }

  highlightOption() {
    const visible = this.getAvailableOptions();

    visible.forEach((option, index) => {
      option.classList.toggle('is-active', index === this.activeIndex);
    });
  }

  selectOption(option) {
    if (!option || option.dataset.disabled === 'true') return;

    this.paramInput.name = option.dataset.paramName;
    this.paramInput.value = option.dataset.paramValue;
    this.paramInput.disabled = false;
    this.input.value = option.dataset.label || option.textContent.trim();
    this.closeList();
    this.form.submit();
  }

  onInput() {
    this.renderOptions();
  }

  onFocus() {
    this.renderOptions();
  }

  onBlur() {
    window.setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.closeList();
      }
    }, 150);
  }

  onKeyDown(event) {
    if (!this.list) return;

    const visible = this.getAvailableOptions();

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      if (this.list.hidden) this.openList();
      this.activeIndex = Math.min(this.activeIndex + 1, visible.length - 1);
      this.highlightOption();
      return;
    }

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.activeIndex = Math.max(this.activeIndex - 1, 0);
      this.highlightOption();
      return;
    }

    if (event.key === 'Enter') {
      event.preventDefault();
      if (this.activeIndex >= 0 && visible[this.activeIndex]) {
        this.selectOption(visible[this.activeIndex]);
      } else if (visible.length === 1) {
        this.selectOption(visible[0]);
      }
      return;
    }

    if (event.key === 'Escape') {
      this.closeList();
    }
  }

  onOptionClick(event) {
    const option = event.target.closest('.wk-home-sector-search__option');
    if (!option) return;

    event.preventDefault();
    this.selectOption(option);
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.closeList();
    }
  }
}

if (!customElements.get('wk-home-facets')) {
  customElements.define('wk-home-facets', WkHomeFacets);
}

if (!customElements.get('wk-home-sector-search')) {
  customElements.define('wk-home-sector-search', WkHomeSectorSearch);
}
